import { DATA_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'uploadedInvalidProspects',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Uploaded Invalid Prospects',
  },
}

const keys = {
  statKey: 'uploaded_invalid_prospects',
  componentKeys: [DATA_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
}

const uploadedInvalidProspects = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { uploadedInvalidProspects }
